import React from 'react'

import { Radio } from 'core-components/library/radio'

import styles from '../Body.module.scss'

interface PermissionsSectionProps {
  disabled: boolean
  allowEmail: boolean
  allowCall: boolean
  onChangeEmail: (val: boolean) => void
  onChangeCall: (val: boolean) => void
}

export const PermissionsSection: React.FC<PermissionsSectionProps> = ({
  disabled,
  allowEmail,
  allowCall,
  onChangeEmail,
  onChangeCall,
}) => {
  return (
    <div className={styles.permissions}>
      <div>Can HP contact you with additional offers, support, updates and news?</div>
      <div className={styles.block}>
        <div className={styles.label}>Email</div>
        <div className={styles.radioGroup}>
          <Radio
            disabled={disabled}
            className={styles.radioGroup__button}
            checked={allowEmail}
            onChange={() => onChangeEmail(true)}
            value="true"
            label="Yes"
          />
          <Radio
            disabled={disabled}
            className={styles.radioGroup__button}
            checked={!allowEmail}
            onChange={() => onChangeEmail(false)}
            value="false"
            label="No"
          />
        </div>
      </div>
      <div className={styles.block}>
        <div className={styles.label}>Phone</div>
        <div className={styles.radioGroup}>
          <Radio
            disabled={disabled}
            className={styles.radioGroup__button}
            checked={allowCall}
            onChange={() => onChangeCall(true)}
            value="true"
            label="Yes"
          />
          <Radio
            disabled={disabled}
            className={styles.radioGroup__button}
            checked={!allowCall}
            onChange={() => onChangeCall(false)}
            value="false"
            label="No"
          />
        </div>
      </div>
    </div>
  )
}
